/** "Needs attention" rows on the dashboards (`dashboard.tasks`) and the admin store page's "Orders" tab. */

import { useQuery } from "@tanstack/react-query";

import { adminOrdersCounts, vendorOrdersCounts } from "@motolynk/api-client";
import { DashboardTask } from "@motolynk/app-core";
import { useTranslation } from "@motolynk/i18n";

import { CustomerOrdersTab } from "./admin/CustomerOrdersTab";

export function AdminOrderTasks() {
  const { t } = useTranslation("orders");
  const counts = useQuery({
    queryKey: ["admin", "orders", "counts"],
    queryFn: async () => (await adminOrdersCounts()).data,
  }).data;
  return (
    <>
      <DashboardTask
        to="/orders?status=stuck"
        icon="alert"
        label={t("tasks.stuck")}
        count={counts?.stuck}
        tone="warning"
      />
      <DashboardTask
        to="/orders?status=placed"
        icon="inbox"
        label={t("tasks.newOrders")}
        count={counts?.placed}
      />
    </>
  );
}

export function VendorOrderTasks() {
  const { t } = useTranslation("orders");
  const counts = useQuery({
    queryKey: ["vendor", "orders", "counts"],
    queryFn: async () => (await vendorOrdersCounts()).data,
  }).data;
  return (
    <>
      <DashboardTask
        to="/orders?status=pending"
        icon="inbox"
        label={t("tasks.toConfirm")}
        count={counts?.pending}
      />
      <DashboardTask
        to="/orders?status=packed"
        icon="truck"
        label={t("tasks.toShip")}
        count={counts?.packed}
      />
    </>
  );
}

/** Admin → store page → "Orders": the store's orders (newest first). */
export function VendorOrdersTab({ vendorUid }: { vendorUid: string }) {
  return <CustomerOrdersTab customerUid="" vendorUid={vendorUid} />;
}
